
<template>
  <div class="page-header">
    <div class="panel panel-default">
      <div class="panel-heading">到店红包简介</div>
      <div class="panel-body">
        <p class="p1">功能简介:</p>
        <p
          class="span1"
        >全新到店引流利器到店红包功能全新推出，到店红包功能是目前流行的O2O线下门店引爆客流的互动红包功能。到店红包功能只允许认证服务号并已开通微信支付，同时配置好微信支付和支付证书，商户平台内留有足够金额后才可以使用。商家可以在红包活动添加一张门店店铺的照片，此照片作为领红包者是否到店的目标图片。参与者到店拍摄一张与目标图片一致的照片并上传，上传照片与目标图片一致后可获得红包。红包发放有两种方式，自动发放只要图片比对一致即可发放，手工发放图片一致并商家在中奖纪录中核对后发放，金额将在活动结束后系统以红包的方式发放到参与者微信中。</p>
        <p class="p1">适用账号:</p>
        <p class="span1">认证服务号并且达到商户平台开通红包的要求</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="less" scoped>
.panel-heading {
  font-weight: 600;
  font-size: 18px;
  color: #333;
  line-height: 20px;
  span {
    float: right;
  }
}
.panel-body {
  color: #666;
  .span1 {
    font-size: 16px;
    margin: 30px 0;
    color: #666;
    line-height: 32px;
    letter-spacing: 1px;
  }
  .p1 {
    margin: 30px 0;
    font-size: 16px;
    font-weight: 600;
    color: #333;
    line-height: 32px;
    letter-spacing: 1px;
  }
}
</style>


